import { render } from "./AlarmOutputSetting.vue?vue&type=template&id=c4f02576"
import script from "./AlarmOutputSetting.vue?vue&type=script&lang=js"
export * from "./AlarmOutputSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__